import {Async, Loaded, Loading } from 'Core/models/Async';

export class UnassignedCISmokingCodes {
    
    public readonly key = 'UnassignedCISmokingCodes';
  }

export type CriticalIllnessSmokingCodes = Async<string[]> | UnassignedCISmokingCodes;

type MatchCriticalIllnessSmokingCodesOptions<TReturn> = {
    Loading: () => TReturn;
    Loaded: (products: string[]) => TReturn;
    Error: () => TReturn;
    Unassigned: (products: []) => TReturn;
  };

export const isLoading = (smokingCodes: CriticalIllnessSmokingCodes): smokingCodes is Loading<string[]> =>
    smokingCodes.key === 'Loading';

export const isLoaded = (smokingCodes: CriticalIllnessSmokingCodes): smokingCodes is Loaded<string[]> => smokingCodes.key === 'Loaded';

export const matchCriticalIllnessSmokingCodes = <TReturn>(options: MatchCriticalIllnessSmokingCodesOptions<TReturn>) => (
    products: CriticalIllnessSmokingCodes
  ) => {
  
    switch (products.key) {
      case 'UnassignedCISmokingCodes':
        return options.Unassigned([]);
      case 'Loaded':
        return options.Loaded(products.Data);
      case 'Loading':
        return options.Loading();
      case 'Conflict':
        return options.Error();
      case 'ServerError':
        return options.Error();
      case 'Unauthorized':
        return options.Error();
    }
  };
  